module.exports = __webpack_public_path__ + "static/media/cosentino-message.7f383785.svg";